module.exports = __webpack_public_path__ + "static/media/Team.47a746cf.png";